module.exports = __webpack_public_path__ + "img/weather36.b5440c68.png";